export default __webpack_public_path__ + "static/media/flyte-full-logo.1c6b4c58.svg";